<lib-switch-input label="Show total" [model]="perspectiveFacade.perspective()?.includeTotal"
                  (modelChange)="handleClick()"/>
